import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Playlists } from "@/components/Playlists";
import { SubmitTrack } from "@/components/SubmitTrack";
import { Faq } from "@/components/Faq";
import { Follow } from "@/components/Follow";
import { Footer } from "@/components/Footer";
import { useTrackPageView } from "@/hooks/useTrackPageView";

const AdminApp = lazy(() => import("./admin/AdminApp"));
const SubmitPage = lazy(() => import("./pages/SubmitPage"));
const JournalPage = lazy(() => import("./pages/JournalPage"));
const ThisWeekPage = lazy(() => import("./pages/ThisWeekPage"));

const pageFallback = <div className="min-h-screen bg-[var(--cream)]" />;

function PublicSite() {
    useTrackPageView();
    return (
        <div className="App grain min-h-screen bg-[var(--cream)]">
            <Header />
            <main>
                <Hero />
                <About />
                <Playlists />
                <SubmitTrack />
                <Faq />
                <Follow />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/admin/*"
                    element={
                        <Suspense fallback={pageFallback}>
                            <AdminApp />
                        </Suspense>
                    }
                />
                <Route
                    path="/submit"
                    element={
                        <Suspense fallback={pageFallback}>
                            <SubmitPage />
                        </Suspense>
                    }
                />
                <Route
                    path="/journal"
                    element={
                        <Suspense fallback={pageFallback}>
                            <JournalPage />
                        </Suspense>
                    }
                />
                <Route
                    path="/this-week"
                    element={
                        <Suspense fallback={pageFallback}>
                            <ThisWeekPage />
                        </Suspense>
                    }
                />
                <Route path="*" element={<PublicSite />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
